import type { Novidade } from './tipos';

/** Fase 2 (W5): Pessoas e empresas numa aba só, ficha fiscal, vínculos, consulta de CNPJ e CEP e campos novos. */
export const novidadeCadastros: Novidade = {
  id: '2026-10-05-cadastros',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'cadastros',
  permissao: 'cadastros.ver',
  textos: {
    pt: {
      titulo: 'Pessoas e empresas numa aba só, com ficha fiscal',
      resumo: 'Clientes, fornecedores, parceiros, contatos e empresas ficam juntos, com filtros e dados fiscais completos.',
      passos: [
        'Em Cadastros, Pessoas e empresas, filtre por papel: clientes, fornecedores, parceiros, contatos ou empresas.',
        'Ao digitar o CNPJ ou o CEP, o sistema consulta e preenche só os campos que estão vazios.',
        'Na ficha, a parte fiscal guarda inscrições, porte, situação e o regime tributário com a vigência.',
        'Ligue pessoas entre si (sócio de, representante de) e cadastre quem é de fora do Brasil com o documento do país.',
      ],
    },
    en: {
      titulo: 'People and companies in one tab, with tax details',
      resumo: 'Customers, suppliers, partners, contacts and companies live together, with filters and complete tax details.',
      passos: [
        'In Records, People and companies, filter by role: customers, suppliers, partners, contacts or companies.',
        'When you type the CNPJ or the postal code, the system looks it up and fills only the empty fields.',
        'On the record, the tax section keeps registrations, size, status and the tax regime with its validity.',
        'Link people to each other (partner of, representative of) and register people outside Brazil with their country document.',
      ],
    },
    es: {
      titulo: 'Personas y empresas en una pestaña, con ficha fiscal',
      resumo: 'Clientes, proveedores, socios, contactos y empresas quedan juntos, con filtros y datos fiscales completos.',
      passos: [
        'En Registros, Personas y empresas, filtra por función: clientes, proveedores, socios, contactos o empresas.',
        'Al escribir el CNPJ o el código postal, el sistema consulta y llena solo los campos vacíos.',
        'En la ficha, la parte fiscal guarda inscripciones, tamaño, situación y el régimen tributario con su vigencia.',
        'Vincula personas entre sí (socio de, representante de) y registra a quien está fuera de Brasil con el documento de su país.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-cadastros/pessoas.webp', null, null, null],
  treinamento: { curso: 'novidades' },
  rota: '/cadastros/cadastros/pessoas',
};
